define(["jquery", "Aheadworks_Ajaxcartpro/js/config"], function (
  $,
  awAcpConfig
) {
  class PdpAddToBagModal {
    constructor() {
      this.$element = $(".pdp-add-to-bag-modal-container");
      this.$content = this.$element.find(".modal-content");
      this.redirectOnContinueClick = false;

      this.bindListeners();
    }

    bindListeners() {
      const self = this;
      this.$element
        .find(".modal-inner-wrap > .close-button-container > .close-button")
        .on("click", function (event) {
          self.close();
        });
    }

    close() {
      $(document.body).trigger("bbntGeneralLoadEnd");

      const $overlay = this.$element.find(".overlay");
      $overlay.removeClass("show");

      const $content = this.$element.find(".modal-content-container");
      $content.removeClass("show");

      const self = this;
      setTimeout(() => {
        self.$content.html("");

        this.$element.removeClass("show");

        document.body.classList.remove("bbnt-modal-visible-scroll-that-only");
      }, 300);
    }

    onChangeRedirectOnContinueClickOutcome(outcome) {
      this.redirectOnContinueClick = outcome;
      this.continueShoppingBinding();
    }

    presentBeforeOpening_whileAddingToBag_loading() {
      $(document.body).trigger("bbntGeneralLoadBegin");
    }

    continueShoppingBinding() {
      const $continueShopping = this.$content.find(
        ".what-was-added-to-my-bag .or-continue-shopping"
      );
      if ($continueShopping && $continueShopping.length > 0) {
        if (this.redirectOnContinueClick && awAcpConfig.productCategoryUrl) {
          $continueShopping.off();
          $continueShopping.attr("href", awAcpConfig.productCategoryUrl);
        } else {
          $continueShopping.attr("href", "javascript:void(0);");
          const self = this;
          $continueShopping.on("click", function (event) {
            event.preventDefault();
            event.stopPropagation();
            self.close();
          });
        }
      }
    }

    overlayCloseBinding() {
      const self = this;
      const $overlay = this.$element.find(".overlay");
      $overlay.on("click", function (event) {
        self.close();
      });
    }

    relatedProductNavigationBinding() {
      this.$content
          .find('.related-items > .product-list > li > a')
          .on('click', ':not(.purchasing-actions-container)', function (event) {
            event.stopImmediatePropagation();

            if (window.dataLayer && window.dataLayer.push) {
              window.dataLayer.push({
                event: 'cross_sell_interaction',
                ecommerce: {
                  url: event.delegateTarget.href,
                  name: event.delegateTarget.querySelector('h4').textContent.trim()
                }
              })
            }
          });
    }

    onUiRetrievedForAddToCart(renderedUi) {
      this.$content.html(renderedUi);
      this.$content.trigger("contentUpdated");

      const $freeshipping = this.$content.find(
        ".product-free-shipping-indicator"
      );
      if ($freeshipping && $freeshipping.length > 0) {
        $freeshipping.applyBindings();
      }

      const $viewBag = this.$content.find(
        ".what-was-added-to-my-bag .view-bag-and-checkout"
      );
      if ($viewBag && $viewBag.length > 0) {
        $viewBag.attr("href", awAcpConfig.checkoutUrl);
      }

      this.continueShoppingBinding();

      this.overlayCloseBinding();
    }

    onUiRetrievedForRelatedProducts(renderedUi) {
      this.$content.append(renderedUi);
      this.$content.trigger("contentUpdated");

      this.relatedProductNavigationBinding();
    }

    presentAddToBagSuccess() {
      $(document.body).trigger("bbntGeneralLoadEnd");

      document.body.classList.add("bbnt-modal-visible-scroll-that-only");

      this.$element.removeClass("hide");
      this.$element.addClass("show");

      this.$element.focus();

      const self = this;
      setTimeout(() => {
        const $overlay = self.$element.find(".overlay");
        $overlay.addClass("show");

        const $content = self.$element.find(".modal-content-container");
        $content.addClass("show");
      }, 0);
    }

    presentAddToBagFailure() {
      this.close();
    }
  }

  let instance = null;
  PdpAddToBagModal.singleton = function () {
    if (!instance) {
      instance = new PdpAddToBagModal();
    }
    return instance;
  };
  return PdpAddToBagModal.singleton();
});
